// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"1e373698","90":"88416ed0","338":"33081110"}[chunkId] + ".chunk.css";
};